export default __webpack_public_path__ + "static/media/chubbies20.8da61c73.png";